import { useTranslation } from "react-i18next";
import { Checkbox, Select, MenuItem, ListSubheader, ListItemText, FormControl, InputLabel } from '@mui/material';



const KeySelector = (props) => {

    const { keys, onChange, onClose } = props;

    const { t } = useTranslation();

    return (
        <FormControl sx={{ minWidth: 120 }} size="small">

            <Select
                value={[""]}
                multiple
                renderValue={(value) => t("Data")}
                onClose={() => onClose()}
            >
                <MenuItem>
                    <Checkbox
                        checked={keys.energy_price}
                        onChange={(event) => { onChange({ ...keys, energy_price: event.target.checked }) }}
                    /><ListItemText primary={t("keyEnergyPrice")} />
                </MenuItem>

                <MenuItem>
                    <Checkbox
                        checked={keys.outside_temp}
                        onChange={(event) => { onChange({ ...keys, outside_temp: event.target.checked }) }}
                    /><ListItemText primary={t("OutsideTemperature")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.carbon_intensity}
                        onChange={(event) => { onChange({ ...keys, carbon_intensity: event.target.checked }) }}
                    /><ListItemText primary={t("CarbonIntensity")} />
                </MenuItem>
                {
                    //removing this option for the time being
                    false && <MenuItem>
                        <Checkbox
                            checked={keys.battery_level}
                            onChange={(event) => { onChange({ ...keys, battery_level: event.target.checked }) }}
                        /><ListItemText primary={t("BatteryLevel")} />
                    </MenuItem>
                }
                <MenuItem>
                    <Checkbox
                        checked={keys.power_meter}
                        onChange={(event) => { onChange({ ...keys, power_meter: event.target.checked }) }}
                    /><ListItemText primary={t("Electricity meter")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.gas_meter}
                        onChange={(event) => { onChange({ ...keys, gas_meter: event.target.checked }) }}
                    /><ListItemText primary={t("Gas meter")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.APPARENT_POWER}
                        onChange={(event) => { onChange({ ...keys, APPARENT_POWER: event.target.checked }) }}
                    /><ListItemText primary={t("APPARENT_POWER")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.VOLTAGE}
                        onChange={(event) => { onChange({ ...keys, VOLTAGE: event.target.checked }) }}
                    /><ListItemText primary={t("VOLTAGE")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.CURRENT}
                        onChange={(event) => { onChange({ ...keys, CURRENT: event.target.checked }) }}
                    /><ListItemText primary={t("CURRENT")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.POWER_FACTOR}
                        onChange={(event) => { onChange({ ...keys, POWER_FACTOR: event.target.checked }) }}
                    /><ListItemText primary={t("POWER_FACTOR")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.on_off}
                        onChange={(event) => { onChange({ ...keys, on_off: event.target.checked }) }}
                    /><ListItemText primary={t("On off")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.fan_speed}
                        onChange={(event) => { onChange({ ...keys, fan_speed: event.target.checked }) }}
                    /><ListItemText primary={t("Fan speed")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.mode}
                        onChange={(event) => { onChange({ ...keys, mode: event.target.checked }) }}
                    /><ListItemText primary={t("Mode")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.humidity}
                        onChange={(event) => { onChange({ ...keys, humidity: event.target.checked }) }}
                    /><ListItemText primary={t("Humidity")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.co2}
                        onChange={(event) => { onChange({ ...keys, co2: event.target.checked }) }}
                    /><ListItemText primary={t("CO2")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.pm10}
                        onChange={(event) => { onChange({ ...keys, pm10: event.target.checked }) }}
                    /><ListItemText primary={t("PM10")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.pm2_5}
                        onChange={(event) => { onChange({ ...keys, pm2_5: event.target.checked }) }}
                    /><ListItemText primary={t("PM2_5")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.voc}
                        onChange={(event) => { onChange({ ...keys, voc: event.target.checked }) }}
                    /><ListItemText primary={t("VOC")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.pressure}
                        onChange={(event) => { onChange({ ...keys, pressure: event.target.checked }) }}
                    /><ListItemText primary={t("Pressure")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.motion}
                        onChange={(event) => { onChange({ ...keys, motion: event.target.checked }) }}
                    /><ListItemText primary={t("Motion")} />
                </MenuItem>
                <ListSubheader>{t("Indoor temperature")}:</ListSubheader>
                <MenuItem value={"temperature_average"}>
                    <Checkbox
                        checked={keys.temperature === "average"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, temperature: "average" }); else onChange({ ...keys, temperature: null }); }}
                    /><ListItemText primary={t("Average")} />
                </MenuItem>
                <MenuItem value={"temperature_average_by_location"}>
                    <Checkbox
                        checked={keys.temperature === "average_by_location"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, temperature: "average_by_location" }); else onChange({ ...keys, temperature: null }); }}
                    /><ListItemText primary={t("Average by location")} />
                </MenuItem>
                <MenuItem value={"temperature_average_by_system"}>
                    <Checkbox
                        checked={keys.temperature === "average_by_system"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, temperature: "average_by_system" }); else onChange({ ...keys, temperature: null }); }}
                    /><ListItemText primary={t("Average by system")} />
                </MenuItem>
                <MenuItem value={"temperature_individual"}>
                    <Checkbox
                        checked={keys.temperature === "individual"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, temperature: "individual" }); else onChange({ ...keys, temperature: null }); }}
                    /><ListItemText primary={t("Individual")} />
                </MenuItem>
                <ListSubheader>{t("SetPoint")}:</ListSubheader>
                <MenuItem value={"set_point_average"}>
                    <Checkbox
                        checked={keys.set_point === "average"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, set_point: "average" }); else onChange({ ...keys, set_point: null }); }}
                    /><ListItemText primary={t("Average")} />
                </MenuItem>
                <MenuItem value={"set_point_average_by_location"}>
                    <Checkbox
                        checked={keys.set_point === "average_by_location"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, set_point: "average_by_location" }); else onChange({ ...keys, set_point: null }); }}
                    /><ListItemText primary={t("Average by location")} />
                </MenuItem>
                <MenuItem value={"set_point_average_by_system"}>
                    <Checkbox
                        checked={keys.set_point === "average_by_system"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, set_point: "average_by_system" }); else onChange({ ...keys, set_point: null }); }}
                    /><ListItemText primary={t("Average by system")} />
                </MenuItem>
                <MenuItem value={"set_point_individual"}>
                    <Checkbox
                        checked={keys.set_point === "individual"}
                        onChange={(event) => { if (event.target.checked) onChange({ ...keys, set_point: "individual" }); else onChange({ ...keys, set_point: null }); }}
                    /><ListItemText primary={t("Individual")} />
                </MenuItem>
                <ListSubheader>{t("Automation")}:</ListSubheader>
                <MenuItem>
                    <Checkbox
                        checked={keys.consumption_money}
                        onChange={(event) => { onChange({ ...keys, consumption_money: event.target.checked }) }}
                    /><ListItemText primary={t("Calculated cost")} />
                </MenuItem>
                <MenuItem>
                    <Checkbox
                        checked={keys.consumption_kwh}
                        onChange={(event) => { onChange({ ...keys, consumption_kwh: event.target.checked }) }}
                    /><ListItemText primary={t("Calculated consumption")} />
                </MenuItem>
            </Select>
        </FormControl>

    )

}

export default KeySelector;